module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.25.0@babel-runtime/core-js/map.js
// module id = 142
// module chunks = 20